var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreePlugins = function SvgFreePlugins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.422 9.583h21.291M12.803 19.885l-5.2-10.302 1.374-5.495h10.99l2.747 5.495zm0 0L1.422 9.583l.968-1.937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.803 19.885 3.73-10.302-1.1-5.495"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m3.944.214.814 2.062 2.063.814-2.063.813-.814 2.063-.813-2.063-2.063-.813 2.063-.814zM20.193 16.462l.813 2.062 2.063.814-2.063.813-.814 2.063-.813-2.063-2.063-.813 2.063-.814z"
  })));
};
export default SvgFreePlugins;